import { render, staticRenderFns } from "./StclPD.vue?vue&type=template&id=767de41c"
import script from "./StclPD.vue?vue&type=script&lang=js"
export * from "./StclPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports